<template>
    <modal title="Berater kontaktieren">
        <form @submit.prevent="submitForm" class="u-form-p-bottom">
            <ion-grid>
                <!-- <ion-row>
          <ion-col>
            CoachContactModal
          </ion-col>
        </ion-row>

        agentId
        headquarter
        bereich
        plznocheck -->

                <base-input
                    type="text"
                    :value="agentName"
                    label="Anfrage an"
                    id="agentName"
                    disabled
                ></base-input>
                <base-input
                    type="text"
                    v-model="product"
                    label="Dein Produkt"
                    id="contract"
                    v-if="product !== ''"
                ></base-input>

                <template
                    v-if="
                        !$store.state.isLoggedIn ||
                        Object.keys($store.state.user.details).length === 0
                    "
                >
                    <base-select
                        id="anrede"
                        v-model="formData.anrede"
                        label="Anrede"
                    >
                        <ion-select-option value="Herr">Herr</ion-select-option>
                        <ion-select-option value="Frau">Frau</ion-select-option>
                    </base-select>

                    <base-input
                        type="text"
                        v-model="formData.titel"
                        label="Titel"
                        id="titel"
                    ></base-input>

                    <base-input
                        type="text"
                        v-model="formData.vorname"
                        label="Vorname"
                        id="vorname"
                    ></base-input>

                    <base-input
                        type="text"
                        v-model="formData.zuname"
                        label="Zuname"
                        id="zuname"
                    ></base-input>
                </template>

                <base-input
                    type="email"
                    v-model="formData.email"
                    label="Deine E-Mail Adresse"
                    id="email"
                ></base-input>

                <base-input
                    type="tel"
                    v-model="formData.telefon"
                    label="Deine Telefonnummer"
                    id="telefon"
                ></base-input>

                <base-textarea
                    id="nachricht"
                    v-model="formData.nachricht"
                    label="Nachricht"
                    :rows="4"
                ></base-textarea>
            </ion-grid>
        </form>
        <template v-slot:footer>
            <ion-button
                @click="submitForm()"
                expand="block"
                class="ion-margin-top"
                :disabled="
                    formData.email === '' ||
                    formData.telefon === '' ||
                    formData.nachricht === ''
                        ? true
                        : false
                "
            >
                <ion-label>Absenden</ion-label>
            </ion-button>
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import BaseInput from "./BaseInput";
import BaseSelect from "./BaseSelect";
import BaseTextarea from "./BaseTextarea";

import { coachContact } from "@/api/coachcontact";

export default {
    props: {
        agentId: {},
        agentName: {},
        contractId: {
            required: false,
            type: String,
            default: "",
        },
        motive: {
            required: false,
            type: String,
            default: "allgemein",
        },
    },
    components: {
        Modal,
        BaseInput,
        BaseSelect,
        BaseTextarea,
    },
    data() {
        return {
            product: "",
            formData: {
                bereich: "",
                anrede: "",
                titel: "",
                vorname: "",
                zuname: "",
                email: "",
                telefon: "",
                nachricht: "",
                plznocheck: true,
            },
        };
    },
    mounted() {
        if (this.$store.state.isLoggedIn) {
            // this.$store.commit("setLoading", true);
            this.$store.cache.dispatch("user/getUserAddress").then(() => {
                let userdetails = this.$store.state.user.details;
                if (Object.keys(userdetails).length > 0) {
                    this.formData.anrede = userdetails.geschlecht;
                    this.formData.titel = userdetails.titel;
                    this.formData.vorname = userdetails.vorname;
                    this.formData.zuname = userdetails.nachname;
                    this.formData.email = userdetails.email;
                    this.formData.telefon = userdetails.telefon;
                    this.formData.plz = userdetails.plz;
                }
            });
            this.formData.bereich = this.motive;
            let productText = "";
            const contracts = this.$store.state.contracts;
            if (contracts[this.contractId]) {
                if (contracts[this.contractId].Name) {
                    productText += contracts[this.contractId].Name + " ";
                }
                if (contracts[this.contractId].ContractIdFormatted) {
                    productText +=
                        "(" +
                        contracts[this.contractId].ContractIdFormatted +
                        ")";
                }
            }
            this.product = productText;
        }
    },
    methods: {
        submitForm() {
            this.$store.commit("setLoading", true);
            let changedFormData = { ...this.formData };
            if (this.product !== "") {
                changedFormData.nachricht =
                    this.formData.nachricht +
                    "\n\n" +
                    "Produkt des Kunden: " +
                    this.product;
            }
            coachContact(this.agentId, changedFormData).then((response) => {
                if (response.data.Status === 200) {
                    if (response.data.Result) {
                        this.$ionic.modalController.dismiss();
                        this.$ionic.alertController
                            .create({
                                header: "Erfolgreich abgesendet",
                                // message: "Möchtest du dieses Dokument wirklich löschen?",
                                buttons: [
                                    {
                                        text: "Ok",
                                        role: "cancel",
                                    },
                                ],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$store.commit("setAskForRating", true);
                                });
                                a.present();
                            });
                    }
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
